import { createAction } from "redux-actions";
import { CLEAR_ERROR, SET_ERROR } from "./constants";

export const clearError = createAction(CLEAR_ERROR);
export const setError = createAction(SET_ERROR);
